import { Github, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="border-t border-white/10 bg-background py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-8 md:mb-0">
            <span className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-primary to-secondary">
              CSS DAO
            </span>
            <p className="mt-2 text-sm text-gray-400 max-w-xs">
              Building the future of Web3 with open collaboration and innovation.
            </p>
          </div>

          <div className="flex space-x-6">
            <a href="https://twitter.com/cssdao" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary transition-colors">
              <span className="sr-only">Twitter</span>
              <Twitter className="h-6 w-6" />
            </a>
            <a href="https://github.com/cssdao" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
              <span className="sr-only">GitHub</span>
              <Github className="h-6 w-6" />
            </a>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-white/5 text-center text-sm text-gray-500">
          &copy; {new Date().getFullYear()} CSS DAO. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
